"use client";

import { useMakeupsEligibilitySettings } from "./useMakeupsEligibilitySettings";

type UseMakeupsAnnualRequestLimitOptions = {
  enabled?: boolean;
};

export function useMakeupsAnnualRequestLimit({
  enabled = true,
}: UseMakeupsAnnualRequestLimitOptions = {}) {
  const settings = useMakeupsEligibilitySettings({ enabled });

  return {
    annualRequestLimit: settings.annualRequestLimit,
    persisted: settings.persisted.annualLimit,
    isPending: settings.isPending,
    isFetching: settings.isFetching,
    isError: settings.isError,
    refetch: settings.refetch,
  };
}

export { useMakeupsEligibilitySettingsUpdate as useMakeupsAnnualRequestLimitUpdate } from "./useMakeupsEligibilitySettings";
